var slickSettings = {
    prevArrow: '<a href="javascript:void(0);" class="slick-prev"><span class="novicon novicon-arrow-left" aria-selected="false"></span></a>',
    nextArrow: '<a href="javascript:void(0);" class="slick-next"><span class="novicon novicon-arrow-right" aria-selected="false"></span></a>',
    swipeToSlide: true,
    accessibility: true
};

$(function () {
    if (typeof (imagesLoaded) == "function") {
        $("[data-slick]").each(function () {
            $(this).imagesLoaded().always(function (e) {
                $(e.elements).slick(slickSettings);
            });
        });
    }
    else {
        $("[data-slick]").each(function () {
            $(this).slick(slickSettings);
        });
    }

    $(document).on("keyup", ".slick-dots li", function (e) {
        if (e.keyCode == 37) {
            $(this).closest(".slick-slider").slick('slickPrev');
        }
        if (e.keyCode == 39) {
            $(this).closest(".slick-slider").slick('slickNext');
        }
    })

});
